var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPencil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1436 8.34444L11.6547 8.85556L6.622 13.8889H6.11096V13.3778L11.1436 8.34444ZM13.1433 5C13.0045 5 12.86 5.05556 12.7545 5.16111L11.738 6.17778L13.821 8.26111L14.8376 7.24444C14.889 7.19305 14.9299 7.132 14.9578 7.06479C14.9857 6.99758 15 6.92554 15 6.85278C15 6.78002 14.9857 6.70797 14.9578 6.64076C14.9299 6.57356 14.889 6.51251 14.8376 6.46111L13.5377 5.16111C13.4266 5.05 13.2878 5 13.1433 5ZM11.1436 6.77222L5 12.9167V15H7.08305L13.2267 8.85556L11.1436 6.77222Z",
    fill: "var(--primary-icon-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/editPencil.1d4a4f31dac6b06e95568bfe43a1a73c.svg";
export { ForwardRef as ReactComponent };